import React from "react";
import ReactDOM from "react-dom/client";
import store from "./store/index";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import "./assets/styles/index.scss";
import App from "./App";
import { PersistGate } from "redux-persist/lib/integration/react";
import { persistStore } from "redux-persist";

let persistor = persistStore(store);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Router>
      <PersistGate loading={null} persistor={persistor}>
      <App />
      </PersistGate>
    </Router>
  </Provider>
);

reportWebVitals();
